import { jsx as _jsx } from "react/jsx-runtime";
// ============================================
// Theme Provider — dark / light toggle
// ============================================
import { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext(undefined);
const STORAGE_KEY = 'pg-theme';
export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        // Read initial value — must match the inline script in index.html
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === 'light' ? 'light' : 'dark';
    });
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        document.documentElement.classList.toggle('dark', theme === 'dark');
        localStorage.setItem(STORAGE_KEY, theme);
    }, [theme]);
    const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
    return (_jsx(ThemeContext.Provider, { value: { theme, toggleTheme, isDark: theme === 'dark' }, children: children }));
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error('useTheme must be used within ThemeProvider');
    return ctx;
}
//# sourceMappingURL=ThemeProvider.js.map